import { MinervaSPA } from '@/components/SPA';

export default MinervaSPA;
